<section id="option-details" class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section
      data-tms-id="TMS_CONTENT_HEADER"
      class="rs-bg-black rs-ph2 rs-ph2-neg rs-ph2-fullimg rs-section-under-header"
      id="betvbanner"
    >
      <div class="row">
        <div class="small-12 medium-6 large-5 column end">
          <div class="rs-ph2-col1-wrapper">
            <div class="rs-fe3"></div>
            <div class="rs-ph2-col1-content">
              <div class="small-only-text-center">
                <div
                  class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>

              <div class="small-only-text-center">
                <div>
                  <div
                    class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div>
                  <div
                    class="panel rs-inline-block rs-wd-s13 rs-wd-m22 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div>
                  <div
                    class="panel rs-inline-block rs-wd-s22 rs-wd-m31 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div>
                  <div
                    class="panel rs-inline-block rs-wd-s15 rs-wd-m20 rs-h-s3 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>

              <div class="rs-flex-row rs-flex-middle rs-flex-dir-col-small-only">
                <div class="rs-flex-columns">
                  <div
                    class="panel rs-wd-s14 rs-wd-s21 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="rs-flex-columns rs-flex-grow">
                  <div
                    class="panel rs-wd-s15 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>
            <div class="rs-le2 hide-for-small-only"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="small-12 column">
          <div
            class="panel rs-maxw rs-h-s10 rs-h-m8 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s17 rs-wd-s23 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-le2"></div>
    </section>
  </main>
</section>
